import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import z from 'zod';
import { createRESTContract } from '../../index';
import {
  TicketDeflectionCreateSchema,
  TicketDeflectionFeedbackSchema,
} from './ticket-deflection.schema';

export const ticketDeflectionContract = createRESTContract({
  submitTicketDeflection: {
    method: 'POST',
    path: '/ticket-deflection/submit',
    permissions: [PERMISSIONS.TICKET_DEFLECTION.TICKET_DEFLECTION_SUBMIT],
    response: z.void(),
    body: TicketDeflectionCreateSchema,
  },
  submitTicketDeflectionFeedback: {
    method: 'POST',
    path: '/ticket-deflection/feedback',
    permissions: [PERMISSIONS.TICKET_DEFLECTION.TICKET_DEFLECTION_FEEDBACK],
    response: z.void(),
    body: TicketDeflectionFeedbackSchema,
  },
});
